

export const APP_NAME = "CafeTime";

export const Routes = {
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  MESSAGES: "/dashboard/messages",
  MY_AVAILABILITY: "/dashboard/my-availability",
  MANAGE_SHIFTS: "/dashboard/manage-shifts",
  TEAM_AVAILABILITY: "/dashboard/team-availability", // Existing, can be refined later
  TEAM: "/dashboard/team", // New: For manager's team list and employee profiles
  SETTINGS: "/dashboard/settings",
};

